const style = (theme) => {
  const output = {
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    wrapper: {
      width: '100%',
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
    },
    intro: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '50%',
    },
    title: {
      color: theme.colors[3],
      fontSize: 95,
      lineHeight: 1,
      marginBottom: 40,
    },
    text: {
      color: theme.colors[5],
      fontSize: 16,
      marginBottom: 80,
    },
    cardList: {
      width: '100%',
      marginBottom: 40,
      '& > *': {
        float: 'left',
        width: '100%',
        '&:nth-child(1)': {
          position: 'relative',
          zIndex: 2,
        },
        '&:nth-child(2)': {
          position: 'relative',
          zIndex: 1,
        },
        '&:nth-child(3)': {
          position: 'relative',
          marginLeft: -30,
          zIndex: 2,
        },
        '&:nth-child(4)': {
          position: 'relative',
          marginLeft: -30,
          zIndex: 1,
        },
        '&:nth-child(5)': {
          position: 'relative',
          zIndex: 2,
        },
      },
      '& .slick-slide': {
        width: '21.8vw !important',
      },
      '& .slick-list': {
        display: 'flex',
        justifyContent: 'center',
      },
    },
  }

  output[theme.mediaInverse.md] = {
    title: {
      fontSize: 60,
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    wrapper: {
      overflow: 'hidden',
    },
    cardList: {
      '& .slick-slide': {
        width: '80vw !important',
      },
      '& .slick-list': {
        justifyContent: 'flex-start',
      },
      '& .slick-track': {
        '& > *:not(:last-child)': {
          marginRight: 20,
        },
      },
    },
    intro: {
      width: '90%',
    },
  }

  return output
}
export default style
